import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { AuthProvider } from './lib/authContext';
import { Toaster } from './components/ui/toaster';

// Capture install events as early as possible so dashboard UI can use one-tap install reliably.
if (typeof window !== 'undefined' && !window.__deaconInstallPromptInitialized) {
  window.__deaconInstallPromptInitialized = true;
  window.__deaconDeferredInstallPrompt = null;

  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    window.__deaconDeferredInstallPrompt = event;
    window.dispatchEvent(new CustomEvent('deacon-install-prompt-available'));
  });

  window.addEventListener('appinstalled', () => {
    window.__deaconDeferredInstallPrompt = null;
    window.dispatchEvent(new CustomEvent('deacon-app-installed'));
  });
}

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Handle service worker updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New content is available, refresh the page
              window.location.reload();
            }
          });
        });
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <Toaster />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
